export enum AUTH_STATE {
  AUTHD = 'authd',
  UNAUTHD = 'unauthd',
}
